import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { takeUntil } from "rxjs";
import { IGif } from "@gtmhub/comments";
import { SizeOfGif } from "@gtmhub/shared/services/tenor-gif.service";
import { DestroyService } from "@webapp/core/util/services/destroy.service";
import { FeatureFlag } from "@webapp/feature-toggles/models/feature-toggles.models";
import { FeatureTogglesFacade } from "@webapp/feature-toggles/services/feature-toggles-facade.service";
import { ReflectionNote } from "@webapp/reflections/models/reflections.models";

@Component({
  selector: "reflection-note",
  templateUrl: "./reflection-note.component.html",
  styleUrls: ["./reflection-note.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReflectionNoteComponent {
  @Input() public note: ReflectionNote;
  @Input() public isEditModeEnabled = false;
  @Output() public readonly noteChange = new EventEmitter<ReflectionNote>();

  public editingStatus = false;
  public sizeOfGif = SizeOfGif;
  public isCheckInsUxImprovementsEnabled: boolean;

  constructor(featureToggleFacade: FeatureTogglesFacade, destroy$: DestroyService) {
    featureToggleFacade
      .isFeatureAvailable$(FeatureFlag.CheckInsUxImprovements)
      .pipe(takeUntil(destroy$))
      .subscribe({
        next: (enabled) => {
          this.isCheckInsUxImprovementsEnabled = enabled;
        },
      });
  }

  public changeEditingStatus(params: { status: boolean }): void {
    if (this.isEditModeEnabled) {
      this.editingStatus = params.status;
      if (!this.note.text) {
        this.note.text = "-";
      }
    }
  }

  public updateNote(newText: string): void {
    this.noteChange.emit({ ...this.note, text: newText });
  }

  public removeNote(): void {
    this.editingStatus = false;
    this.noteChange.emit({ ...this.note, text: "", gif: null });
  }

  public removeDefaultText(): void {
    if (this.note.text === "-") {
      this.removeNote();
    }
  }

  public gifChange(gif: IGif): void {
    this.noteChange.emit({ ...this.note, gif: gif?.id ? gif : null });
  }
}
